import { FC, useCallback, useState } from 'react'

import { VehicleReminder } from '../../sdk'
import { AutomatedSendReminderCreateDialog } from './AutomatedSendReminderCreateDialog'
import { AutomatedSendReminderMainDialog } from './AutomatedSendReminderMainDialog'

interface Props {
  handleClose: () => void
  vehicleReminders: VehicleReminder[]
}

export const AutomatedSendReminderContainer: FC<Props> = ({
  handleClose,
  vehicleReminders
}) => {
  const [
    openAutomatedSendReminderMainDialog,
    setOpenAutomatedSendReminderMainDialog
  ] = useState<boolean>(true)
  const [
    openCreateAutomatedSendReminderDialog,
    setOpenCreateAutomatedSendReminderDialog
  ] = useState<boolean>(false)

  const handleCloseMainDialog = useCallback(async () => {
    setOpenAutomatedSendReminderMainDialog(false)
    handleClose()
  }, [handleClose])

  const handleOpenCreateDialog = useCallback(async () => {
    setOpenCreateAutomatedSendReminderDialog(true)
    setOpenAutomatedSendReminderMainDialog(false)
  }, [])

  const handleCloseCreateDialog = useCallback(async () => {
    setOpenCreateAutomatedSendReminderDialog(false)
    setOpenAutomatedSendReminderMainDialog(true)
  }, [])

  return (
    <>
      {openAutomatedSendReminderMainDialog && (
        <AutomatedSendReminderMainDialog
          open={openAutomatedSendReminderMainDialog}
          handleClose={handleCloseMainDialog}
          handleCreate={handleOpenCreateDialog}
        />
      )}

      {openCreateAutomatedSendReminderDialog && (
        <AutomatedSendReminderCreateDialog
          open={openCreateAutomatedSendReminderDialog}
          handleClose={handleCloseCreateDialog}
          vehicleReminders={vehicleReminders}
        />
      )}
    </>
  )
}
